// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-collapse {
  display: flex;
}
.conn-form-collapse__component {
  height: 28px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/preparedRows/CollapseRow/CollapseRow.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,YAAA;AACR","sourcesContent":[".conn-form-collapse {\n  display: flex;\n}\n.conn-form-collapse__component {\n  height: 28px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
